import * as React from 'react';
import { type TickActions } from './types';
import { Button } from '../../../../components';

export type ApplicationViewTableTickActionsProps = {
  tickedApplicationIds: string[];
  tickActions?: TickActions[];
};

export const ApplicationViewTableTickActions: React.FunctionComponent<
  ApplicationViewTableTickActionsProps
> = props => {
  const { tickedApplicationIds, tickActions = [] } = props;

  return (
    <div className="flex flex-wrap">
      {tickActions.map((customAction, index) => {
        const {
          disable = false,
          handleAction,
          icon,
          label,
          title,
        } = customAction;
        const handleEditApplication = (): void => {
          handleAction(tickedApplicationIds);
        };
        return (
          <Button
            title={title}
            variant="text"
            className="!mb-2 !normal-case"
            key={`tick-action-${index}`}
            disabled={disable || !tickedApplicationIds.length}
            startIcon={icon}
            onClick={handleEditApplication}
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
};
